<template>
  <div :class="['container',  _isMobile()?'mobile':'']">
    <!-- <a-card class="search-card" :bordered="false">
      <j-dict-select-tag
        :defaultShowAll="true"
        type="radioButton"
        @change="handleChangeType"
        v-model="courseType"
        :trigger-change="true"
        dictCode="course_type"
      />
    </a-card>
    <a-divider /> -->
    <h2>我的课程</h2>
    <a-divider></a-divider>
    <a-card :bordered="false">
      <a-skeleton v-if="loading"/>
      <a-list
        :grid="{ gutter: _isMobile()?12:24, lg: 3, md: 2, sm: 2, xs: 1 }"
        :dataSource="dataSource"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card :bordered="false" @click="toDetail(item)">
            <img class="cover" :src="item.courseCover_url" alt="">
            <h3 class="title">{{ item.courseName }}</h3>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG,ACCESS_TOKEN } from "@/store/mutation-types";
import {getAction} from "@/api/manage"
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      dataSource: [
      ],
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: this._isMobile()?8:12,
      },
      loading: true,
      courseType: "",
      token: '',
      tenantConfig:{}
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (Vue.ls.get(ACCESS_TOKEN)){
      this.token = Vue.ls.get(ACCESS_TOKEN)
    }
    this.getCourseList()
    this.getNewCourse()
  },
   mounted(){
    window.document.title = this.tenantConfig.brandName + " " +"课程教学"
  },
  methods: {
    handleChangeType(v) {
      this.courseType = v.target.value
      this.getCourseList()
    },
    getNewCourse(){
        getAction("/teaching/teachingCourse/getNewCourse",{
            dayRange: 100,
            limit: 1
        }).then(res=>{

        })
    },
    getCourseList(){
      this.loading = true
      this.dataSource = []
        getAction("/teaching/teachingCourse/studentCourseNew", {
          courseType: this.courseType,
           pageSize:999, 
          //  isShow:1
           }).then(res=>{
          console.log(res);
          if(res.success){
            this.dataSource = res.result
          }
          this.loading = false
        })
    },
    toDetail(course){
      this.$router.push({
        path: '/course/detail',
        query: {
          id: course.id,
          departId: course.departId,
          source: 'my'
        },
      })
    }
  },
};
</script>

<style lang="less" scoped>
.cover{
  width: 100%;
  height: 170px;
}
.title{
  margin-top: 5px;
}
.title:hover{
  color: #1890FF;
}
.search-card{
  /deep/.ant-card-body{
    padding: 20px;
  }
}
/deep/.ant-list-item{
  cursor: pointer;
  .ant-card-body{
    padding: 0;
  }
}

.mobile{
  .cover{
    height: 100px!important;
  }
}
</style>